/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable no-unused-vars */
import React, {
  useContext, useEffect, useState, useMemo, useRef
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'

import CheckoutLayout from '@apps/components/CheckoutLayout'

import { setPageAnalytics } from '@apps/utils/Analytics'

import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'
import Heading2 from '@apps/components/Typography/Heading2'
import ActivateSIMSection from '@apps/flows/activation/sections/ActivateSIMSection'
import {
  APPLICATION_STATE,
  ApplicationContext,
  ModifyApplicationContext,
  setLandingLogicLoader,
  setActivateAllTrigerred
} from '@apps/contexts/ApplicationContext'
import { setESimNumber } from '@apps/redux/features/SimSelectionSlice'
import {
  PAYMENT_STATE, updatePaymentStates, paymentSummary, paymentVoucher
} from '@apps/redux/features/PayAndReviewSlice'
import {
  PAYMENT_OPTIONS, SIM_OPTIONS, VALID_AVS_CODES, PHONE_NUMBER_OPTIONS, CARD_VALIDATION_ERRORS, ANALYTICS_EVENT_TYPES, PAGE_NUMBER, QUOTE_STATE
} from '@apps/utils/constants'
import { getActivateAllReqPayload } from '@apps/utils/requestPayloadHelper'
import { ControlledModal, Spinner, Icon, Card, Typography, Button } from '@telus/koodo-ui-kit'
import {
  ACCOUNT_SETUP_STATE,
  updateAccountSetupState
} from '@apps/redux/features/AccountSetupSlice'
import { PHONE_NUMBER_STATE, updatePhoneNumberState } from '@apps/redux/features/PhoneNumberSlice'
import { PLANS_STATE, updatePlansState } from '@apps/redux/features/PlansSlice'
import {
  updateActivateAllResponse,
  setQuoteInfo,
  setActivationQrCode,
  setIsSimValidFlag
} from '@apps/redux/features/CommonSlice'
import Sites from '@sites/index'
import useSite from '@engine/hooks/useSite'
import { getById, getBySlug } from '@apps/utils/contentful'
import PlanUnavailablePopup from '@apps/components/PlanUnavailablePopup'
import { getPromoNames } from '@apps/utils/common'
import { isActivationOutcomePath } from '@apps/utils/navigation'
import { keepOnlyAutoPromo } from '@apps/utils/autoPromo'
import PaymentOption from './PaymentOption'
import PromoCode from './PromoCode'
import useLocale from '../../../_engine/hooks/useLocale'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const PaymentPage = () => {
  const dispatch = useDispatch()
  const {
    content: { pageContent, featureFlags }
  } = useSelector((state) => state.common)

  const appState = useContext(ApplicationContext)
  const setAppState = useContext(ModifyApplicationContext)

  const { lang } = useLocale()

  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const { userType } = useSelector((state) => state.common)
  const paymentState = useSelector((state) => state.payAndReviewPage)
  const { quote } = useSelector((state) => state.common)
  const { simNumber } = useSelector((state) => state.simSelectionPage)
  const { simType } = useSelector((state) => state.simSelectionPage.selectSimType)

  const tagManagerInfo = useTagManagerInfo()

  const { plan } = useSelector((state) => state.plansPage)

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, target_link, field_warning, customer_ban, error_response_code, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        field_warning,
        error_response_code,
        customer_ban,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  const [showActivatingPopup, setShowActivatingPopup] = useState(false)
  const [isProcessingPayment, setIsProcessingPayment] = useState(false)
  const [isActivateButtonDisabled, setIActivateButtonDisabled] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [isActivateAllProcessing, setIsActivateAllProcessing] = useState(true)
  // A counter, not a boolean. Each activation attempt has to be able to navigate,
  // and a flag that is already true produces no state change - so on a retry the
  // effect watching it would never re-run and the customer would sit on Payment
  // while activateAll ran invisibly behind them. Only reachable since the EPS
  // session refresh made retrying on this page possible (MASC-16812).
  const [loaderNavigationRequest, setLoaderNavigationRequest] = useState(0)

  const [buttonIsLoading, setButtonIsLoading] = useState(false)
  // Local safeguard ref for activateAll in-progress lock
  const activatingRef = useRef(false)
  // isCompleteEPS as of the latest render, readable from callbacks that were
  // created in an earlier one. activateSimCard is handed to EPSCard as a prop and
  // runs from a closure captured before validateCardDetails clears
  // ccApiValidationError - and that error is one of the inputs to isCompleteEPS,
  // so a plain read there sees the pre-retry `false` and skips the navigation.
  const isCompleteEPSRef = useRef(false)

  const contextState = {
    application: useContext(ApplicationContext),
    accountSetup: useSelector((state) => state.accountSetupPage),
    simSelectionPage: useSelector((state) => state.simSelectionPage),
    phoneNumber: useSelector((state) => state.phoneNumberPage),
    plans: useSelector((state) => state.plansPage),
    payment: useSelector((state) => state.payAndReviewPage),
    common: useSelector((state) => state.common)
  }

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const resetPromoRafAndVoucherState = () => {
    updatePaymentStore({
      // Clear all manually entered RAF / promo-code fields.
      [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE]: '',
      [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_INFO]: '',
      [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false,
      [PAYMENT_STATE.PROMO.PROMOTION_CODE]: '',
      [PAYMENT_STATE.PROMO.PROMOTION_CODE_INFO]: '',
      [PAYMENT_STATE.PROMO.PROMOTION_VALIDATION_CODE]: '',
      [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE]: '',
      [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false,
      [PAYMENT_STATE.PROMO.MULTI_PROMOTION_VALIDATION_CODE]: '',
      // Keep the plan's auto promo — it is not user-entered, and before the MFE
      // work nothing cleared these arrays between pages, so emptying them here
      // dropped the promo on any return to payment (MASC-17223).
      ...keepOnlyAutoPromo({
        promo: plan?.promo,
        multiPromotionCodeInfo,
        autoPromoText
      }),
      // Reset computed summary amounts so OrderSummary recalculates from
      // scratch rather than briefly showing stale discounted totals that
      // the previous session's async tax fetch left in Redux.
      ...paymentSummary,
      // Drop the vouchers the user applied here. paymentSummary above zeroes
      // amountTotalVoucher, but PlanCardFooter deducts from addedVouchers
      // directly, so leaving the list behind kept the voucher credit — and a
      // $0.00 "due now" — on the plans page after the user navigated back
      // (MASC-17336).
      ...paymentVoucher,
    })
  }

  const site = useSite()

  const {
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.PROVINCE_GROUPS]: provinceGroups = [],
  } = contextState.application

  const {
    [PHONE_NUMBER_STATE.PROVINCE_ID]: provinceId
  } = contextState.phoneNumber

  const {
    activateAll, getCity, isSimValid, retrieveQuoteByEmail, getRafSettings
  } = brandServices

  const {
    [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: selectedPaymentOption,
    [PAYMENT_STATE.AUTO_TOP_UPS]: autoPay,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
    [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: multiPromoCodes
  } = contextState.payment

  // Same Contentful slug the plans page and landing logic use to label the
  // plan's auto promo in the multi-promo arrays.
  const plansPagePrefix = userType === Sites.dealer ? 'Dealer' : 'Consumer'
  const autoPromoText = getBySlug(
    getById(pageContent, `plansPage${plansPagePrefix}`)?.[lang]?.shortTextFields,
    'autoPromoText'
  )?.value

  const {
    [PLANS_STATE.PRE_SELECTED_PLAN]: preSelectedPlan
  } = contextState.plans
  const usePreSelectedPlanOptions = preSelectedPlan && userType === Sites.consumer

  const {
    [PAYMENT_STATE.RAF.FRIEND_REFERRAL_SETTINGS]: friendReferralSettings,
    [PAYMENT_STATE.PAYMENT_GATEWAY]: paymentGateway,
    [PAYMENT_STATE.SUMMARY.TAX_PROVINCE]: taxProvince,
  } = paymentState

  const history = useHistory()
  const location = useLocation()

  /*
    activateAll came back in a shape we cannot act on - no data, and no error
    message to show. Route to ProcessFailure rather than leaving the customer on
    Payment, for the same reason the sibling error branch does: by this point
    EPSCard has already spent the EPS session on the tokenize that produced the
    token we just submitted, and nothing refreshes it on the accepted path. A
    retry from this page would tokenize against the spent session and come back
    40002. ProcessFailure's Retry re-routes through navigateToPath, so EPSCard
    remounts and mints a fresh session on the way back.
  */
  const activateAllFailedUnexpectedly = (responseError) => {
    // Release the re-entry guard first: without it every later press is a silent
    // no-op, which outlives this navigation.
    activatingRef.current = false
    setIsActivateAllProcessing(false)
    setIActivateButtonDisabled(false)
    setButtonIsLoading(false)
    setShowActivatingPopup(false)

    dispatch(updateActivateAllResponse({ responseError }))

    history.push(
      site === Sites.consumer
        ? consumerActivationPaths.ProcessFailure
        : dealerActivationPaths.ProcessFailure
    )
  }

  const activateSimCard = async (paymentResult = '') => {
    setButtonIsLoading(false)
    // Early re-entry guard: if already activating, exit
    if (activatingRef.current) {
      return
    }
    let parsedPaymentResult = null
    const voucherAutoPaySelected = selectedPaymentOption === PAYMENT_OPTIONS.VOUCHER && autoPay

    if (selectedPaymentOption === PAYMENT_OPTIONS.CREDIT_CARD || voucherAutoPaySelected) {
      let isValidPaymentResult
      if (paymentGateway === 'EPS') {
        parsedPaymentResult = paymentResult
        isValidPaymentResult = paymentResult
      } else {
        parsedPaymentResult = Object.fromEntries(
          paymentResult?.split('\n')?.map((pair) => pair?.split('='))
        )
        isValidPaymentResult =
          parsedPaymentResult &&
          parsedPaymentResult.APPROVED === 'true' &&
          VALID_AVS_CODES.includes(parsedPaymentResult.AVS_RESPONSE_CODE) &&
          parsedPaymentResult.STORAGE_TOKEN_ID
      }

      if (isValidPaymentResult) {
        updatePaymentStore({
          [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: '',
          [PAYMENT_STATE.CC_INFO.MASKED]: parsedPaymentResult.CARD_NUMBER
        })
      } else {
        updatePaymentStore({
          [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: CARD_VALIDATION_ERRORS.FAILED
        })
        setButtonIsLoading(false)
        setIsProcessingPayment(false)
        setShowActivatingPopup(false)
        setIActivateButtonDisabled(false)
        return
      }
    }

    setIsProcessingPayment(false)
    setShowActivatingPopup(false)
    setIActivateButtonDisabled(true)

    const simNum = simNumber?.replace(/[-\s]/g, '') || quote?.quoteInfo?.SimInformation?.simNumber
    const isSimNumValid = simNum ? await isSimValid(simNum) : ''

    if (simNum && (!isSimNumValid || isSimNumValid === null) && (simType === SIM_OPTIONS.H_SIM)) {
      dispatch(setIsSimValidFlag(isSimNumValid))
      setActivateAllTrigerred(false)
      history.push(consumerActivationPaths.SimSelection)
      return
    }

    const requestPayload = getActivateAllReqPayload(contextState, parsedPaymentResult)
    handleFirstLoaderComplete()
    // Check safeguard right before activateAll; return if already in-flight
    if (activatingRef.current) {
      return
    }
    // Flip local safeguard immediately before network call
    activatingRef.current = true
    const response = await activateAll(requestPayload)
    setShowActivatingPopup(false)
    if (response) {
      if (response.error && response.error.message && !response?.data) {
        const res = await retrieveQuoteByEmail({ email: requestPayload?.emailAddress })
        if (res?.data?.quoteId) {
          dispatch(setQuoteInfo(res.data))
        }

        setIsActivateAllProcessing(false)
        // Reset local guard on error so retry is allowed
        activatingRef.current = false

        dispatch(updateActivateAllResponse({ responseError: response?.error }))

        // error loader and hide loader
        setErrorMessage(response.error)
        pushClickAnalytics({ click_text: 'Activate SIM clicked', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Activation Failed', field_warning: response?.error?.message, error_response_code: response?.error?.code })


        //  error loader
        // 1 . generic errro and  retrieve button
        // 2. payment and label ( submitquote success )
        // 3. after success submitquote api  any api error no label - customer support
        // When retrieveQuote reports the user is back on Phone Number Selection
        // (typical when their reserved number was activated by another customer
        // during dwell), skip ProcessFailure and land on the Phone Number page
        // directly — the "unavailable" popup fires from Redux state on mount.
        const failedAtPhoneNumber = res?.data?.currentState === QUOTE_STATE.PHONE_NUMBER_SELECTION
        if (failedAtPhoneNumber) {
          // Clear the user's previously-selected number from the phone-number
          // slice so (a) the ChooseNumber form doesn't pre-populate with the
          // now-unavailable number, and (b) LocationSelector's `isNumbersLoaded`
          // initializes to false, letting the "unavailable" popup gate open.
          dispatch(updatePhoneNumberState({
            [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER]: '',
            [PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.PHONE_NUMBER]: ''
          }))
        }
        if (site === Sites.consumer) {
          history.push(failedAtPhoneNumber ? consumerActivationPaths.ChooseNumber : consumerActivationPaths.ProcessFailure)
        } else {
          history.push(failedAtPhoneNumber ? dealerActivationPaths.ChooseNumber : dealerActivationPaths.ProcessFailure)
        }

        return
      }
      if (response.data) {
        dispatch(setESimNumber(response?.data?.eSimNumber))
        dispatch(
          updateAccountSetupState({
            [ACCOUNT_SETUP_STATE.BAN]: response?.data?.ban
          })
        )

        dispatch(setActivationQrCode(response?.data?.activationQRCode))

        dispatch(updateActivateAllResponse({ postPaymentError: response?.error }))
        if (site === Sites.consumer) {
          history.push(consumerActivationPaths.TransactionSummary)
        } else {
          history.push(dealerActivationPaths.TransactionSummary)
        }
      } else {
        // activateAll came back with neither data nor a usable error message.
        activateAllFailedUnexpectedly(response?.error)
      }
    } else {
      // activateAll resolved falsy altogether.
      activateAllFailedUnexpectedly(undefined)
    }
  }

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  // Payment config comes from the feature flags getAllPagesData already put in
  // Redux, scoped to this portal. This previously called Contentful directly from
  // the browser and always asked for the Consumer entry, so dealers — who reach
  // this same page — were handed consumer payment config. Note the Contentful
  // field names differ from the Redux state keys: paymentCvvResponseValue /
  // paymentAvsPostalResponseValue vs paymentcvvResponseValue /
  // paymentAvsPostalResponse. Reading with the Redux spellings is why those two
  // were never applied (MASC-17283).
  const setInitialPaymentState = () => {
    const paymentConfig = featureFlags?.[0]

    if (paymentConfig?.paymentGateway) {
      updatePaymentStore({ [PAYMENT_STATE.PAYMENT_GATEWAY]: paymentConfig.paymentGateway })
    }
    if (paymentConfig?.paymentAllowedCountryCodes) {
      updatePaymentStore({
        [PAYMENT_STATE.PAYMENT_ALLOWED_COUNTRY_CODES]: paymentConfig.paymentAllowedCountryCodes
      })
    }
    if (paymentConfig?.paymentCvvResponseValue) {
      updatePaymentStore({
        [PAYMENT_STATE.PAYMENT_CVV_RESP_VAL]: paymentConfig.paymentCvvResponseValue
      })
    }
    if (paymentConfig?.paymentAvsPostalResponseValue) {
      updatePaymentStore({
        [PAYMENT_STATE.PAYMENT_AVS_POSTAL_RESP_VAL]: paymentConfig.paymentAvsPostalResponseValue
      })
    }
    updatePaymentStore({ [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: PAYMENT_OPTIONS.CREDIT_CARD })
  }

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, {
        ...tagManagerInfo,
        promoCodeDescription: plan?.promo?.bundles?.map(bundle => bundle.name).join(', ') || 'NA'
      })
    )
  }

  useEffect(() => {
    if (userType === Sites.dealer && identity) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language, identity])

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  useEffect(() => {
    // getCity looks cities up by province, so without one there is nothing to
    // ask for: the service returns undefined and the .map below threw, which the
    // catch reported as "error on city fetch" on every load. A port-in has no
    // provinceId, since the number was never chosen from our pool.
    // LocationSelector guards the same call the same way.
    if (provinceId && provinceGroups?.length === 0) {
      getCity(provinceId)
        .then((result) => {
          // undefined when the province has no groups — see operations.getCity.
          // Return rather than storing an empty array: provinceGroups is a
          // dependency of this effect, so writing a fresh [] would change its
          // reference, re-run the effect, find length 0 again and fetch in a
          // loop. Previously the map threw here, which stopped the write by
          // accident.
          if (!result?.length) return
          const resultCities = result.map((item) => {
            const { value, id } = item
            const cityName = value.split('-')[1]
            const name =
              cityName && cityName[0]
                ? cityName[0].toUpperCase() + cityName.slice(1).toLowerCase()
                : value
            return {
              value: id,
              name,
              groupName: value
            }
          })
          setAppState({ ...appState, [APPLICATION_STATE.PROVINCE_GROUPS]: resultCities })
        })
        .catch((e) => {
          console.log('error on city fetch', e)
        })
    }
    // Depend on the count, not the array: provinceGroups is destructured with a
    // `= []` default, so it is a fresh reference on every render where the value
    // is unset — enough on its own to re-run this effect and refetch.
  }, [provinceId, getCity, provinceGroups?.length])

  // Fetched through the proxy so the Contentful delivery token stays server-side.
  // Returns null when the backend Contentful client is unavailable, in which case
  // the existing referral defaults are left in place (MASC-17283).
  const updateReferralSetting = async () => {
    const referralSettings = await getRafSettings().catch(() => null)
    if (referralSettings) {
      updatePaymentStore({ [PAYMENT_STATE.RAF.FRIEND_REFERRAL_SETTINGS]: referralSettings })
    }
  }

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  useEffect(() => {
    if (!friendReferralSettings) {
      updateReferralSetting()
    }
  }, [friendReferralSettings])

  useEffect(() => {
    // Clear promo/RAF/voucher state and stale summary amounts when PaymentPage
    // UNMOUNTS (user navigates away to Plans or any other page).
    // Clearing on unmount avoids a React child-before-parent effect race:
    // OrderSummary (child) fires its async tax fetch before PaymentPage's
    // (parent) mount effect could clear state, causing stale amounts to
    // persist. Unmount guarantees Redux is clean before PlansPage renders.
    return () => {
      // The push has already happened by the time this cleanup runs, so
      // history.location is the destination. Submitting the activation also
      // unmounts this page — zeroing the summary there would wipe the totals
      // the transaction summary is about to render.
      const isMovingToOutcome = isActivationOutcomePath(
        history.location?.pathname,
        consumerActivationPaths,
        dealerActivationPaths
      )
      if (isMovingToOutcome) return
      resetPromoRafAndVoucherState()
    }
  }, [])

  useEffect(() => {
    // Clear plan-level promo on MOUNT so any catalog promo from a newly
    // selected plan does not auto-appear in OrderSummary on PaymentPage
    // re-entry. Manual promo codes entered by the user are separate and
    // handled by the unmount cleanup above.
    dispatch(updatePlansState({ [PLANS_STATE.PROMO]: null }))
  }, [])

  // Separate from the mount-only promo clear above: feature flags arrive
  // asynchronously from getAllPagesData, so this has to re-run when they land.
  useEffect(() => {
    setInitialPaymentState()
  }, [featureFlags])

  // Landing logic leaves the flag in flight for logged-in arrivals — nothing
  // downstream clears it — so the payment page releases the loader itself.
  //
  // Wait for pageContent before doing so: the copy is fetched separately by
  // getAllPagesData, and releasing without it paints the page with empty labels
  // and blank buttons for as long as that request takes, then re-renders once it
  // lands. Every other page stays covered until landing logic finishes, which is
  // why the flash was unique to this one.
  useEffect(() => {
    const landingLogicInFlight = appState.is_landing_logic_not_complete === true
      || appState.is_landing_logic_not_complete === 'IN_PROGRESS'

    // pageContent is an array, and [] is truthy — check it actually holds
    // entries, as SimSelectionPage does, or an empty response would release the
    // loader onto the same blank copy this exists to prevent.
    const hasLoadedContent = Array.isArray(pageContent) && pageContent.length > 0

    if (landingLogicInFlight && hasLoadedContent) {
      setLandingLogicLoader(false)
    }
  }, [appState.is_landing_logic_not_complete, pageContent])

  // Keeps the ref above in step with every render, so callbacks created in an
  // earlier one still read the current value.
  useEffect(() => {
    isCompleteEPSRef.current = contextState?.payment?.[PAYMENT_STATE.IS_COMPLETE_EPS] === true
  })

  useEffect(() => {
    if (loaderNavigationRequest > 0) {
      // Mirror the synchronous error handler: if the quote came back on
      // Phone Number Selection, skip ProcessFailure and route to the Phone
      // Number page directly so the "unavailable" popup fires there.
      const failedAtPhoneNumber = quote?.quoteInfo?.currentState === QUOTE_STATE.PHONE_NUMBER_SELECTION
      if (failedAtPhoneNumber && isActivateAllProcessing === false) {
        // Same clear as the synchronous handler — defensive in case the
        // fast-error branch reaches this useEffect first.
        dispatch(updatePhoneNumberState({
          [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER]: '',
          [PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.PHONE_NUMBER]: ''
        }))
      }
      if (site === Sites.consumer) {
        if (isActivateAllProcessing === true) {
          history.push(consumerActivationPaths.ProcessLoader)
        } else {
          history.push(failedAtPhoneNumber ? consumerActivationPaths.ChooseNumber : consumerActivationPaths.ProcessFailure)
        }
      } else if (site === Sites.dealer) {
        if (isActivateAllProcessing === true) {
          history.push(dealerActivationPaths.ProcessLoader)
        } else {
          history.push(failedAtPhoneNumber ? dealerActivationPaths.ChooseNumber : dealerActivationPaths.ProcessFailure)
        }
      }
    }
  }, [loaderNavigationRequest])

  const showSplashing = featureFlags?.[0]?.showSplashing
  useEffect(() => {
    if (!showSplashing) return
    const splashPath = site === Sites.dealer
      ? dealerActivationPaths.Splash
      : consumerActivationPaths.Splash
    history.push(splashPath)
  }, [showSplashing, history, site])

  const [showErrors, setShowErrors] = useState(false)
  const showAllErrors = () => {
    setButtonIsLoading(false)
    setShowErrors(true)
    updatePaymentStore({ [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: true })
  }

  const resetShowErrors = () => {
    setShowErrors(false)
  }

  const textContent = useMemo(() => {
    const txtObj = {
      shortTextFields: {},
      longTextFields: {}
    }
    if (!pageContent) return txtObj

    const paymentPage =
      site === Sites.consumer
        ? getById(pageContent, 'paymentPageConsumer')[lang]
        : getById(pageContent, 'paymentPageDealer')[lang]

    const shortTextFields = paymentPage?.shortTextFields
    const longTextFields = paymentPage?.longTextFields
    if (shortTextFields && shortTextFields?.length > 0) {
      shortTextFields?.map((item) => {
        txtObj.shortTextFields[item?.slug] = item?.value
      })
    }
    if (longTextFields && longTextFields?.length > 0) {
      longTextFields?.map((item) => {
        txtObj.longTextFields[item?.slug] = item?.value
      })
    }

    return txtObj
  }, [lang, pageContent])

  const {
    activatingSIMCard,
    step,
    plans,
    title,
    chatBot,
    chatBotUrlLabel,
    chatBotUrl,
    chatBot2,
    moreInfo,
    clickHere,
    moreInfoUrl,
    ok,
    createATicket
  } = textContent?.shortTextFields

  const handleSelectNewPhoneNumber = () => {
    dispatch(
      updatePhoneNumberState({
        [PHONE_NUMBER_STATE.PROVINCE_ID]: undefined
      })
    )
    if (userType === Sites.consumer) {
      history.push(consumerActivationPaths.ChooseNumber)
    } else {
      history.push(dealerActivationPaths.ChooseNumber)
    }
  }

  const handleSelectNewPlan = () => {
    if (userType === Sites.consumer) {
      history.push(consumerActivationPaths.Plans)
    } else {
      history.push(dealerActivationPaths.Plans)
    }
  }

  const handleFirstLoaderComplete = () => {
    // Read through the ref, not contextState: this runs from a closure captured
    // before validateCardDetails cleared ccApiValidationError, so the snapshot
    // still says the payment form is incomplete on a retry.
    if (isCompleteEPSRef.current === true) {
      // A new request starts here, so say so before asking for the navigation.
      // The effect below picks between the loader and the failure page on this
      // flag, and a previous attempt may have left it false - which would send a
      // customer whose activateAll is about to run to ProcessFailure instead.
      setIsActivateAllProcessing(true)
      setLoaderNavigationRequest((request) => request + 1)
    }
  }

  if (showSplashing) {
    return null
  }

  return (
    <>
      <CheckoutLayout
        heading={
          <Heading2 className="mt-6 sm:mt-10">
            {textContent?.shortTextFields?.paymentHeaderTitle}
          </Heading2>
        }
        activeStepIndex={usePreSelectedPlanOptions ? PAGE_NUMBER.PLAN_PRESELECTED_PAYMENT : PAGE_NUMBER.PAYMENT}
      >
        <Card variant={{ padding: 'intermediate', borderRadius: 'large' }}>
          <PaymentOption
            showErrors={showErrors}
            onPaymentOptionChange={resetShowErrors}
            handleSIMActivation={activateSimCard}
            textContent={textContent}
            setButtonIsLoading={setButtonIsLoading}
            promoCodeSlot={<PromoCode {...textContent} />}
          />

          <ActivateSIMSection
            showAllErrors={() => showAllErrors()}
            handleSIMActivation={activateSimCard}
            showActivatingPopup={showActivatingPopup}
            setShowActivatingPopup={setShowActivatingPopup}
            setIsProcessingPayment={setIsProcessingPayment}
            isProcessingPayment={isProcessingPayment}
            setIActivateButtonDisabled={setIActivateButtonDisabled}
            paymentGateway={paymentGateway}
            isActivateButtonDisabled={isActivateButtonDisabled}
            setIsActivateAllProcessing={setIsActivateAllProcessing}
            buttonIsLoading={buttonIsLoading}
            setButtonIsLoading={setButtonIsLoading}
          />
        </Card>
      </CheckoutLayout>

      <ControlledModal isOpen={showActivatingPopup} showControls={false}>
        <div className="flex flex-col items-center p-10 text-center">
          <div className="mb-10">
            <Typography variant={{ size: 'h1' }} tokens={{ color: '#000000' }} block>{activatingSIMCard}</Typography>
          </div>
          <Spinner show color="#000000" />
        </div>
      </ControlledModal>

      <ControlledModal isOpen={!!errorMessage} onClose={() => setErrorMessage(null)}>
        {errorMessage && (
          <div className="flex flex-col items-center p-10">
            <div className="mb-10">
              <Typography variant={{ size: 'h1' }} tokens={{ color: '#000000' }} block>{activatingSIMCard}</Typography>
            </div>
            <div className="inline-flex space-x-4">
              <Icon icon="ExclamationOctagon" variant={{ color: 'danger' }} className="self-start" />
              <div className="ml-2 space-y-4 text-black">
                <Typography block>{title}</Typography>
                <Typography block>
                  {chatBot}
                  {chatBotUrlLabel && (
                    <a
                      className="font-h1 text-black"
                      href={chatBotUrl}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => pushClickAnalytics(chatBotUrlLabel)}
                    >
                      {chatBotUrlLabel}
                    </a>
                  )}
                  {chatBot2}
                </Typography>
                <Typography variant={{ colour: 'danger' }} block>
                  {moreInfo}
                  <a
                    className="font-h1 text-black"
                    href={moreInfoUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => pushClickAnalytics(clickHere)}
                  >
                    {clickHere}
                  </a>
                </Typography>
                <Typography variant={{ colour: 'danger' }} block testId="transactionSummary-errorCode">{`Error Code: ${errorMessage.code}`}</Typography>
                {createATicket && <Typography variant={{ colour: 'danger' }} block>{createATicket}</Typography>}
              </div>
            </div>
            <div className="mt-12">
              <Button
                onPress={() => setErrorMessage(null)}
                tokens={{ backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' }}
              >
                {ok}
              </Button>
            </div>
          </div>
        )}
      </ControlledModal>

      <PlanUnavailablePopup
        province={taxProvince}
        onNewPhoneNumberClick={handleSelectNewPhoneNumber}
        onNewPlanClick={handleSelectNewPlan}
        disableClose
      />
    </>
  )
}

export default PaymentPage
